/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientImageCard/Preview/Content"
  
}) {
let patientImageUrlValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'url',
})
  return (<React.Fragment
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="patient_image.url"
 url={patientImageUrlValueData}
 position="relative"
 width="100%"
 height="100%"
/>
{children}
</React.Fragment>)
}